import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { field } from "../app/schema";
import moment from "moment";

export const PATCH_FIELD = "PATCH_FIELD";

export const DELETE_FIELD = "DELETE_FIELD";
export const DELETE_FIELD_SUCCESS = "DELETE_FIELD_SUCCESS";
export const DELETE_FIELD_ERROR = "DELETE_FIELD_ERROR";

export const SET_IS_REMOVE_FIELD_MODAL_VISIBLE = "SET_IS_REMOVE_FIELD_MODAL_VISIBLE";
export const SET_IS_ADD_FIELD_MODAL_VISIBLE = "SET_IS_ADD_FIELD_MODAL_VISIBLE";
export const MOVE_FIELD = "MOVE_FIELD";

// Requests

const patchField = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/fields/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteField = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/fields/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych pola, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

// Actions

export function updateField(data, uid) {
  if (data.get("fieldType") === "date") {
    data = data.set("value", moment(data.get("value"), "DD.MM.YYYY").format());
  }
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_FIELD],
    payload: {
      promise: patchField(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, field);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeField(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_FIELD],
    payload: {
      promise: deleteField(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsRemoveFieldModalVisible(value) {
  return {
    type: SET_IS_REMOVE_FIELD_MODAL_VISIBLE,
    payload: {
      isOpen: value
    }
  };
}

export function setIsAddFieldModalVisible(value) {
  return {
    type: SET_IS_ADD_FIELD_MODAL_VISIBLE,
    payload: {
      isOpen: value
    }
  };
}

export function moveField(dragIndex, hoverIndex, moveActionProps) {
  return {
    type: MOVE_FIELD,
    payload: {
      dragIndex,
      hoverIndex,
      moveActionProps
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/fields/actions.js